module.exports = __webpack_public_path__ + "static/img/userinfo-gold-bg.99ba6d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member-system/userinfo-gold-bg.png
// module id = YTuy
// module chunks = 215